import $ from "jquery";
import m, {Vnode, VnodeDOM} from "mithril";
import {LabelItem} from "../../../../model/items/labelItem";
import {RadioItem} from "../../../../model/items/radio";

export default class NumericScaleItem {

    private npsContainer: any;
    private focused: string|null = null;
    public afterPickValue: null|((value:string) => void) = null;

    constructor(
        private readonly items: RadioItem[],
        private readonly edgeLabels: LabelItem[] = [],
        private initFocused: string|null = null,
    ) { }


    public get value(): string|null {
        const value = this.items[0].getVariable();
        return value === undefined ? null : (''+value);
    }

    private elementsCount() {
        return this.items.length;
    }

    private createNpsElements(): Vnode
    {
        const els = [];
        const selectedElement = this.value;
        const magnify = this.focused !== null ? this.focused : (selectedElement === null ? this.initFocused : selectedElement);

        const questionary = this.items[0].form.questionary;

        for (const item of this.items) {
            const i = item.getValue();
            const label = questionary.renderText(item.childrenTags[0]?.value || '') || i;
            els.push(
                m(
                    ".nps-el.nps-el-"+label+(selectedElement===i?'.selected':'')+(magnify===i?'.magnify':''),
                    {
                        tabindex: 1,
                    },
                    ''+label
                )
            );
        }

        return m('.nps-els'+(selectedElement === null ? '.without-value' : ''), {
            onmouseenter: (e: MouseEvent) => this.determineFocusedElement(e.pageX, e),
            onmousemove: (e: MouseEvent) => this.determineFocusedElement(e.pageX, e),
            onmouseleave: () => this.focused = null,
            onclick: (e: MouseEvent) => this.determineFocusedElement(e.pageX, e, true),
            ontouchmove: (e: TouchEvent) => this.determineFocusedElement(e.touches[0].pageX, e, true),
            ontouchend: () => this.focused = null,
        }, els);
    }

    private determineFocusedElement(x: number, e: Event, select = false): void {
        const $npsEls = $(<HTMLElement>e.currentTarget);
        const focusedIndex = Math.min(this.elementsCount()-1, Math.max(0,Math.floor((x-$npsEls.offset().left)/$npsEls.width()*this.elementsCount() )));
        this.focused = this.items[focusedIndex].getValue();
        if (select) {
            this.items[focusedIndex].set();
            if (this.afterPickValue) {
                this.afterPickValue(this.focused);
            }
        }
    }

    private labelView(label?: LabelItem): Vnode|null {
        if (!label) {
            return null;
        }
        const questionary = label.cell.grid.questionary;
        const text = label.childrenTags.filter(t => t.tag === 'text')[0]?.value;
        return m('.', {}, m.trust(questionary.renderText(text ?? '')));
    }

    public view(): Vnode {
        return m('.nps-labels-wrapper.nps-labels-wrapper-'+this.items.length+'.'+this.items[0].variableName+'.'+this.items[0].getVariable(), {}, [
            this.createNpsElements(),
            m('.labels', {}, this.edgeLabels.map(l => this.labelView(l))),
        ])
    }

    oncreate(vnode: VnodeDOM) {
        this.npsContainer = $(vnode.dom).find('.stars');
    }

}